import React from 'react'
import PropTypes from 'prop-types'
import gql from 'graphql-tag'
import {Mutation} from 'react-apollo'
import {Table, notification} from 'antd'
import {ExportOutlined, DeleteOutlined} from '@ant-design/icons'
import Button from 'components/shared/Button'

const deleteSharingMutation = gql`
  mutation RemoveProductsSharing($input: RemoveProductsSharingInput!) {
    RemoveProductsSharing(input: $input) {
      destroyedProductsSharingId
    }
  }
`

const SharingList = ({sharings, refetch}) => {
  return (
    <div className="sharing-list">
      <Table
        dataSource={sharings}
        columns={[
          {title: 'Navn', dataIndex: 'recipientName', key: 'name'},
          {title: 'E-post', dataIndex: 'recipientEmail', key: 'email'},
          {title: 'Telefon', dataIndex: 'recipientPhone', key: 'phone'},
          {title: 'Varighet', dataIndex: 'expiresAt', key: 'expiresAt'},
          {title: '', key: 'actions', render: (text, record) => (
            <span className="sharing-actions">
              <a href={record.url} target="_blank" rel="noopener noreferrer">
                <Button icon={<ExportOutlined />} />
              </a>
              <Mutation
                mutation={deleteSharingMutation}
                onCompleted={() => {
                  refetch()
                  notification['success']({
                    message: 'Delingslenke slettet',
                    description: 'Delingslenke er nå slettet.',
                  })
                }}
                onError={() => {
                  notification['error']({
                    message: 'Sletting feilet',
                    description: 'Kunne ikke slette delingslenke grunnet en feil. Forsøk på nytt senere.',
                  })
                }}
              >
                {(deleteSharing) => (
                  <Button
                    icon={<DeleteOutlined />}
                    onClick={() => {
                      deleteSharing({variables: {
                        input: {
                          productsSharingId: record.id,
                        }
                      }})
                    }}
                  />
                )}
              </Mutation>
            </span>
          )}
        ]}
      />
    </div>
  )
}

SharingList.propTypes = {
  sharings: PropTypes.array.isRequired,
  refetch: PropTypes.func.isRequired,
}

export default SharingList
